import React, { useContext, useState } from 'react';
import { Accordion, AccordionContext, Card } from 'react-bootstrap';
import color from '../../assets/colors';
import icons from '../../assets/icons/icons';
import API from '../../config/config';
import { PhotoSwipe } from 'react-photoswipe';

const CustomToggle = ({ eventKey }: any) => {
  const currentEventKey = useContext(AccordionContext);
  const isCurrentEventKey = currentEventKey === eventKey;

  if (isCurrentEventKey) {
    return icons.negetive(color.$black, '');
  } else {
    return icons.plus(color.$black, '');
  }
};

const Faqs = ({ data }: any) => {
  const [imageReturn, setimageReturn]: any = useState([]);
  const [state, setstate] = useState({
    isOpen: false
  });

  const photoSwipephoto = (image: any) => {
    setstate({
      isOpen: true
    });

    let ImageReturn: { h: number; w: number; src: string }[] = [];

    ImageReturn.push({ h: image.height, w: image.width, src: API.baseUrl + image.url });
    setimageReturn(ImageReturn);
  };

  const renderContent = (items: any) => {
    if (items.answer === null) {
      return (
        <img
          src={items.answerImage ? API.baseUrl + items.answerImage.url : ''}
          width="100%"
          alt={items.answerImage ? items.answerImage.alternativeText : ''}
          onClick={() => photoSwipephoto(items.answerImage)}
        />
      );
    } else {
      return <div dangerouslySetInnerHTML={{ __html: items.answer }} />;
    }
  };

  const Pophandle = () => {
    setstate({
      isOpen: !state.isOpen
    });
  };

  return (
    data && (
      <div className="faq-container-background">
        <div className="container">
          <Accordion>
            {data.faqs &&
              data.faqs.Faqs.length > 0 &&
              data.faqs.Faqs.map((items: any, i: string) => {
                return (
                  <Card key={i}>
                    <Accordion.Toggle as={Card.Header} eventKey={i + 1} className="according-header">
                      {items.question}
                      <span className="faq-custome-toggle">
                        <CustomToggle eventKey="1" />
                      </span>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={i + 1}>
                      <div className="according-body">{renderContent(items)}</div>
                    </Accordion.Collapse>
                  </Card>
                );
              })}
          </Accordion>
        </div>
        <PhotoSwipe isOpen={state.isOpen} items={imageReturn} onClose={Pophandle} />
      </div>
    )
  );
};

export default Faqs;
